import React from 'react';
import Picture from '../../../shared/components/Picture';

function TeamSection({
  abbreviation,
  logoUrl,
  backgroundColor,
  score,
  showScore,
  reverse = false,
}) {
  const scoreEl = showScore && (
    <span className="mls-c-priority-match__score">{score ?? 0}</span>
  );

  return (
    <div
      className="mls-c-priority-match__team-section"
      style={{ '--team-color': backgroundColor }}
    >
      {reverse ? (
        <>
          {scoreEl}
          <Picture
            src={logoUrl}
            title={abbreviation}
            extraClasses="mls-c-priority-match__team-logo"
            className="mls-c-priority-match__team-logo"
          />
          <span className="mls-c-priority-match__team-abbr">
            {abbreviation}
          </span>
        </>
      ) : (
        <>
          <span className="mls-c-priority-match__team-abbr">
            {abbreviation}
          </span>
          <Picture
            src={logoUrl}
            title={abbreviation}
            extraClasses="mls-c-priority-match__team-logo"
            className="mls-c-priority-match__team-logo"
          />
          {scoreEl}
        </>
      )}
    </div>
  );
}

export default TeamSection;
